import React from 'react'

const History = () => {
    
    const [readMore, setReadMore] = React.useState(false)

    return (
        <div className='history flex centerflex vertcenter secPad'>
            <div className="container-lg cardPix flexcol centerflex vertcenter">
                <h2 className='cardTitle'>History</h2>
                <p className={readMore ? '' : 'readmore'}>The scales represent protection, isolation, and strength. For crocodiles, this represented everything and more, even their lineage and the way they ruled. When the lakes were not entirely divided among their inhabitants they were governed by the strongest, the most durable, and imposing. The crocodiles, born from the depths of these lakes on a rainy day in which many died, showed how powerful they were from the first day they stepped on those lands where the strongest ruled. Everyone could appreciate their bright eyes that when looking at you it was impossible not to feel threatened, their powerful fangs and claws that with them destroyed their prey and opponents but, what most impressed and intimidated everyone was their bright and strong green scales, which with them could overcome many, endure rainy and stormy days demonstrating how powerful and invincible these could be, thus starting the most powerful crocodile lineage of all time.</p>
                <button className={readMore ? 'hidden' : 'btn readBtn'} onClick={() => setReadMore(true)}>Read more</button>
            </div>
        </div>
    )
}

export default History
